module.exports = __webpack_public_path__ + "static/media/filters.913edbac.svg";